import { gql } from 'graphql-tag'

import { addressFields } from '../addressFields'

/**
 * CWA-scoped order fragment — field-for-field what CWA sent before this package
 * owned it.
 *
 * Not converged on the shared `orderFields` superset: four of the fields it adds
 * are non-nullable, and CWA reads them through `getOrderByTrackingIdCWA` rather
 * than the resolver CMA exercises. If that resolver leaves any unset, null
 * propagation blanks the whole `order` and the public tracking page renders
 * empty. Converging needs a staging probe on the authed and anonymous paths
 * first — see CBP-3932.
 */
export const orderFieldsCWA = gql`
  fragment OrderFieldsCWA on Order {
    alert {
      title
      body
    }
    address {
      ...AddressFields
    }
    originalAddress {
      street
      city
      state
      zipCode
    }
    addressId
    addressCorrectionAllowed
    authedUserOwnsOrder
    clientName
    clientDisplayName
    clientId
    consumerId
    calculatedOrderInformation {
      orderDeliveryDates
      isDeliveryByEvening
    }
    calculatedPackagesInformation {
      deliveredPackages {
        groupedByDeliveredAtTime {
          deliveredAt
          trackingIds
        }
        total
      }
      notDeliveredPackages {
        groupedByDeliveryDate {
          deliveryDate
          trackingIds
        }
        groupedByDeliveryWindow {
          endsAt
          startsAt
          trackingIds
        }
        groupedByEveningPackages
        groupedByMissingDeliveryDate
        total
      }
      notPickedUpPackages {
        groupedByPickUpDate {
          pickUpDate
          trackingIds
        }
        groupedByPickUpWindow {
          endsAt
          startsAt
          trackingIds
        }
      }
      totalPackages
    }
    deliveryDate
    deliveryDateInfo {
      date
      dateType
      hasBeenUpdated
    }
    orderId
    packages {
      requiresSignatureByPin
      pin
      deliveryTimeWindow {
        endsAt
        startsAt
      }
      eventLog {
        operation
        timestamp
        facility {
          facilityId
          city
          state
        }
        message
      }
      packageId
      trackingId
      timeZone
      scheduledServiceDate
      consumerSupportCase {
        caseId
        caseCategory
        caseDetails
        caseStatus
      }
    }
    timeZone
    serviceType
    reroutableZipCodes
    instructionEditsAllowed
    hasInstructions
    hasCode
    hasApartment
    isOrderReroutable
    isOrderReroutableByConsumer
    rerouteBlockedByClient
  }
  ${addressFields}
`
